import type { Resource } from "models";
import { APIService } from "services";

class ResourceService extends APIService<Resource> {
  async getRawData(resourceId: string, revision: number): Promise<string> {
    const response = await fetch(
      `/portal/api/v1/resources/${resourceId}/${revision}/base64raw`,
      { method: "GET" },
    );

    // Get base64-encoded string from response
    const base64String = await response.text();

    // Decode base64 to get original content
    try {
      return atob(base64String);
    } catch {
      // Return as-is (might already be decoded)
      return base64String;
    }
  }

  async getRawDataAsJson<T = any>(resourceId: string, revision: number): Promise<T> {
    const decoded = await this.getRawData(resourceId, revision);
    const trimmed = decoded?.trim();
    if (!trimmed) {
      return {} as T;
    }
    try {
      return JSON.parse(trimmed) as T;
    } catch {
      return {} as T;
    }
  }
}

export default new ResourceService("resources");
